<template>
  <b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9">
          <b-row class="border">
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Oficinas por marcas</h4>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link href="/clients-by-brands">Listado de marcas</b-link>
                </b-col>
              </b-row> -->
              <div class="mt-2"></div>
              <b-table striped hover :items="brands" :fields="fields">
                <template slot="actions" slot-scope="row">
                  <b-btn size="sm" @click.stop="details(row.item)">Ver oficinas</b-btn>
                </template>
              </b-table>
              <ul v-if="errors && errors.length">
                <li v-for="(error, index) in errors" :key="index">
                  <b-alert show>{{error.message}}</b-alert>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from 'axios'
import Header from './Header'
import Menu from './Menu'
export default {
  name: 'SupervisorOffices',
  components:{
    Header,
    Menu
  },
  data () {
    return {
      fields: {
        name: { label: 'Marca', sortable: true, 'class': 'text-center' },
        actions: { label: '', 'class': 'text-center' }
      },
      brands: [],
      errors: [],
      marcas: ''
    }
  },
  created () {
    document.title = 'Administración Derco - Oficinas por marcas'
    axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    axios.get(`/api/users/` + localStorage.getItem('id'))
    .then(response => {
      console.log(response.data);
      this.marcas = response.data.brand;
      var arrayMarcas = this.marcas.split(",");
      console.log(arrayMarcas);
      //var myJsonString = JSON.stringify(arrayMarcas);
      //this.brands = myJsonString;
      var marcaDatos = {};
      var ordenMarca = []
      marcaDatos.ordenMarca = ordenMarca;
      var i;
      for(i=0;i<arrayMarcas.length;i=i+1){
        var nombreMarca = arrayMarcas[i];
        var arraymmarca = arrayMarcas[i].toLowerCase().split();
        var marcaMinuscula = arraymmarca[0];
        var marca = {
          "name": nombreMarca,
          "slug": marcaMinuscula
        }
        marcaDatos.ordenMarca.push(marca);
      }
      console.log(marcaDatos);
      //this.brands = JSON.parse(marcaDatos.ordenMarca);
      this.brands = JSON.parse(JSON.stringify(marcaDatos.ordenMarca))
      console.log(this.brands);
    })
    .catch(e => {
      this.errors.push(e)
      if(e.response.status === 401) {
        this.$router.push({
          name: 'Login'
        })
      }
    })
  },
  methods: {
    details (brand) {
      this.$router.push({
        name: 'SupervisorShowOfficeDetails',
        params: { slug: brand.slug, brand: brand.name }
      })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Supervisor/Offices.vue